import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import M from 'materialize-css/dist/js/materialize.min.js';
import {logout} from '../store/authActions';
import Navbar from './Navbar';
import AutoLogout from './AutoLogout';
import {getAccounts,clearErrors,setStartTime,clearAccountFilter} from '../store/teachActions';
import TeachAddAccounts from './TeachAddAccounts';
import TeachDelAccounts from './TeachDelAccounts';
import TeachDisableAccounts from './TeachDisableAccounts';
import TeachResetAccounts from './TeachResetAccounts';
import TeachActionLogs from './TeachActionLogs';
import TeachAccountFilter from './TeachAccountFilter';
import AccountContent from './AccountContent';

const TeachHome = ({userid,token,loading,logout,getAccounts,accounts,clearErrors,message,error,secrets,history,wip,setStartTime,startTime,accountfiltered,clearAccountFilter}) => {
  const [action, setAction] = useState('listAccounts');

  useEffect(()=>{
    if(startTime===null) setStartTime();
  //eslint-disable-next-line
  },[]);

  useEffect(()=>{
    if(secrets!==null && secrets.length>0){
      history.push('/teachaccountadded');
    }
  },[secrets,history]);

  useEffect(()=>{
    if(token===null) logout();
    if(userid.gidNumber && userid.gidNumber!=='2000000') logout();
  //eslint-disable-next-line
  },[userid,token]);

  useEffect(()=>{
    if(message) M.toast({html: `${message}`, classes: 'green darken-1', displayLength: 5000});
    if(error) {
      M.toast({html: `${error}`, classes: 'red darken-2', displayLength: 5000});
      getAccounts();
    }
    setTimeout(()=>clearErrors(),2000);
  //eslint-disable-next-line
  },[message,error]);


  const [show, setShow] = useState(false);
  useEffect(()=>{
    setTimeout(()=>setShow(true),500);
  //eslint-disable-next-line
  },[show]);

  useEffect(()=>{
    if(action==='listAccounts'){
      clearAccountFilter();
      getAccounts();
      setShow(false);
    }
  //eslint-disable-next-line
  },[action]);

  const onActionChange = e => setAction(e.target.value);

  return (
    <>
      { !loading
          ? <>
              <Navbar title={'Teach Account Management'}/>
              <AutoLogout />

              <form>
                <div className='row container ' style={{'padding':'10px 10px 10px 10px'}}>
                  <label className='col s2'>
                    <input checked={action==='listAccounts'} onChange={onActionChange} name='action' value='listAccounts' type='radio' className='with-gap' />
                    <span className='blue-grey-text text-darken-4'>List</span>
                  </label>
                  <label className='col s2'>
                    <input checked={action==='addAccounts'} onChange={onActionChange} name='action' value='addAccounts' type='radio' className='with-gap' />
                    <span className='blue-grey-text text-darken-4'>Create</span>
                  </label>
                  <label className='col s2'>
                    <input checked={action==='delAccounts'} onChange={onActionChange} name='action' value='delAccounts' type='radio' className='with-gap' />
                    <span className='blue-grey-text text-darken-4'>Delete</span>
                  </label>
                  <label className='col s2'>
                    <input checked={action==='disableAccounts'} onChange={onActionChange} name='action' value='disableAccounts' type='radio' className='with-gap' />
                    <span className='blue-grey-text text-darken-4'>Disable</span>
                  </label>
                  <label className='col s2'>
                    <input checked={action==='resetAccounts'} onChange={onActionChange} name='action' value='resetAccounts' type='radio' className='with-gap' />
                    <span className='blue-grey-text text-darken-4'>Reset</span>
                  </label>
                  <label className='col s2'>
                    <input checked={action==='actionLogs'} onChange={onActionChange} name='action' value='actionLogs' type='radio' className='with-gap' />
                    <span className='blue-grey-text text-darken-4'>Logs</span>
                  </label>
                </div>
              </form>

              { action==='listAccounts' && accounts && accounts.length===0 &&
                <p className='container'>no associcated teach accounts</p>
              }
              { !show && <div className='progress valign-wrapper'> <div className='indeterminate'></div></div> }
              { action==='listAccounts' && show && accounts.length>0 && <TeachAccountFilter /> }
              { action==='listAccounts' && show && accountfiltered === null && <AccountContent acc={accounts} /> }
              { action==='listAccounts' && show && accountfiltered !== null && <AccountContent acc={accountfiltered} /> }

              { action==='addAccounts' && <TeachAddAccounts /> }
              { action==='delAccounts' && <TeachDelAccounts /> }
              { action==='disableAccounts' && <TeachDisableAccounts /> }
              { action==='resetAccounts' && <TeachResetAccounts /> }
              { action==='actionLogs' && <TeachActionLogs /> }

              { wip && <div className='progress valign-wrapper'> <div className='indeterminate'></div></div>}
            </>
          : <div className='progress valign-wrapper'> <div className='indeterminate'></div></div>
      }
    </>
  );

};

const matStoreToProps = state => ({
  token: state.auth.token,
  loading: state.auth.loading,
  userid: state.auth.userid,
  accounts: state.teach.accounts,
  message: state.teach.message,
  error: state.teach.error,
  secrets: state.teach.secrets,
  wip: state.teach.wip,
  startTime: state.teach.startTime,
  accountfiltered: state.teach.accountfiltered
});
export default connect(matStoreToProps,{logout,getAccounts,clearErrors,setStartTime,clearAccountFilter})(TeachHome);
/*
              { action==='listAccounts' && show &&
                  accountfiltered !== null
                  ? <AccountContent acc={accountfiltered} /> : <AccountContent acc={accounts} />
              }
*/
